const url = {
  // 获取顶域
  getTopDomain: () => {
    let domain = '';
    let suffix = [ 'com', 'cn', 'net', 'org', 'xyz', 'cc' ];
    for (let i in document.domain.split('.')) {
      if (suffix.includes(document.domain.split('.')[i])) {
        domain = document.domain.split('.').slice(i - 1).join('.');
        break;
      }
    }
    return domain;
  },
  // 获取登录页地址
  getLoginUrl: () => {
    const http = location.protocol + '//';
    const domain = process.env.VUE_APP_LOGOUT_DOMAIN + '.' + url.getTopDomain();
    return http + domain;
  }
}

export default url;